import { appRoutes } from '../../shared/routes/app-routes';
import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { navItems } from '../../_nav';
import { HeaderService } from '../header/header.service';
import { canSeeMenuItem, normalizePermission } from '../menu-permission';

@Component({
  selector: 'ss-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: false
})
export class SideMenuComponent implements OnInit, AfterViewInit {
  readonly appRoutes = appRoutes;
  readonly helpCenterUrl = 'https://meajuda.spotpass.com.br/';
  public navItems = navItems;
  public isReduced = false;
  public isOpen = false;
  public permissionList: string[] = [];
  public currentSubmenu = '';
  public userActions: any = {};
  public username = '';
  public userInitials = '';
  public userImage = '';
  public totalUnread = 0;
  public isDocked = false;

  constructor(
    private router: Router,
    private headerService: HeaderService) { }

  ngOnInit() {
    this.updateCurrentSubmenu(this.router.url);

    this.headerService.getUserData().subscribe((response: any) => {
      this.permissionList = (response.menu_permissions || [])
        .map((perm: string) => normalizePermission(perm));

      this.userActions = response.permissions || {};
      this.username = response.username || '';
      this.userImage = response.avatar || '';
      this.userInitials = response.avatar ? '' : this.getUserInitials(this.username);
    });

    this.headerService.getTotalUnreadNotification().subscribe((res: any) => {
      this.totalUnread = res?.total_unread || 0;
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateCurrentSubmenu(event.urlAfterRedirects || event.url);
        this.closeMobileDrawer();
      });
  }

  private getUserInitials(name: string): string {
    const matches = (name || '').match(/\b\w/g) || [];
    return ((matches.shift() || '') + (matches.pop() || '')).toUpperCase();
  }

  closeMobileDrawer(): void {
    const menu = document.querySelector('.ss-side-menu');
    const backdrop = document.querySelector('.ss-side-menu__backdrop');
    menu?.classList.remove('is-mobile-open');
    backdrop?.classList.remove('is-mobile-open');
  }

  logout(): void {
    this.closeMobileDrawer();
    const logoutBtn = document.querySelector<HTMLElement>('.ss-header__logout-btn');
    if (logoutBtn) {
      logoutBtn.click();
    } else {
      window.localStorage.clear();
      window.location.href = '/';
    }
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    const bandHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--band-height')) || 290;
    this.isDocked = window.scrollY >= bandHeight - 72;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.updateCurrentSubmenu(this.router.url);
    }, 500);
  }

  private updateCurrentSubmenu(url: string) {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    this.currentSubmenu = '/' + cleanUrl.split('/').filter(Boolean).slice(0, 2).join('/');
  }

  isModuleActive(item: any): boolean {
    const children = this.showMenuItem(item);
    return children.some((child: any) => child.url === this.currentSubmenu);
  }

  showMenuItem(item: any) {
    return (item.children || []).filter((child: any) => canSeeMenuItem(child.permission, this.permissionList, this.userActions));
  }
}
